import './EnvironmentBadge.css';

interface EnvironmentBadgeProps {
  env: string;
}

function EnvironmentBadge({ env }: EnvironmentBadgeProps): JSX.Element {
  return ['dev', 'uat', 'mt', 'pt'].includes(env.toLowerCase()) ? (
    <span className={'badge ' + env.toLowerCase()}>{env.toUpperCase()}</span>
  ) : (
    <></>
  );
}

export default EnvironmentBadge;
